// extracted by mini-css-extract-plugin
module.exports = {"defaultLink":"ExternalLink_defaultLink__BDBWC","lineItemLink":"ExternalLink_lineItemLink__YZVZ0"};